import React from 'react';

import { flagStyles } from '../settings';

const SvgUG = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-5472px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgUG;
